export default {
  min: 'Mín',
  max: 'Máx'
}
